import { defineNuxtPlugin } from "nuxt/app";
import axios from 'axios';

let userServiceAxiosAccessToken = null as string | null;
export const setUserServiceAxiosAccessToken = (_accessToken: string) => {
  userServiceAxiosAccessToken = _accessToken;
};

export default defineNuxtPlugin((nuxtApp) => {
  // Axiosインスタンスの作成
  const axiosInstance = axios.create({
    baseURL: useRuntimeConfig().public.userServiceBaseUrl as string
  });

  // リクエストインターセプタの追加
  axiosInstance.interceptors.request.use(config => {
    if (userServiceAxiosAccessToken !== null) {
      config.headers.setAuthorization(`Bearer ${userServiceAxiosAccessToken}`);
    }
    return config;
  });

  // レスポンスインターセプタの追加
  axiosInstance.interceptors.response.use(response => {
    if (response.status === 422) {
      // バリデーションエラーの場合は、そのままエラーとして返す
      return Promise.reject(response);
    } else if (response.status !== 200) {
      // その他エラー
      return Promise.reject(response.data);
    } else {
      // 正常終了
      return response;
    }
  });

  // Nuxtアプリケーションにaxiosインスタンスを追加
  nuxtApp.provide('userServiceAxios', axiosInstance);
});
